import React, { lazy, Suspense } from 'react'
import { Outlet, RouteObject } from 'react-router'
import { SuspenseLoading } from '@/common/components/SuspenseLoading.tsx'
import { ProtectedRoutes } from '@/common/layouts/ProtectedRoutes.tsx'
import { EmployeeTimeOffConfigProvider } from '@/pages/time-off/hooks/useEmployeeTimeOffConfig.ts'
import { useAuth } from '@/common/hooks/useAuth.ts'
import dayjs from 'dayjs'
import { DocumentStorageConfigProvider } from '@/pages/employee-data/hooks/useDocumentStorageConfig.tsx'

const MyTimeOffPage = lazy(() => import('@/pages/time-off/my-time-off-page.tsx'))
const TimeOffConfigPage = lazy(() => import('@/pages/time-off/time-off-config-page.tsx'))
const TimeOffReportsPage = lazy(() => import('@/pages/time-off/time-off-reports-page.tsx'))
const TimeOffApprovalPage = lazy(() => import('@/pages/time-off/time-off-approval-page.tsx'))
const EmployeeTimeOffPage = lazy(() => import('@/pages/time-off/employee-time-off-page.tsx'))
const TimeOffCalendarPage = lazy(() => import('@/pages/time-off/time-off-calendar-page.tsx'))

export const timeOffRoutes: RouteObject = {
  path: 'time-off',
  element: (
    <Suspense fallback={<SuspenseLoading />}>
      <DocumentStorageConfigProvider documentBucket="employee">
        <ProtectedRoutes
          requiredPermissions={[{
            moduleName: 'employee-data',
            functionName: 'manage-time-off-configuration',
          }]}
        />
      </DocumentStorageConfigProvider>
    </Suspense>
  ),
  children: [
    { index: true, element: <TimeOffConfigPage /> },
    { path: 'reports', element: <TimeOffReportsPage /> },
    { path: 'employee', element: <EmployeeTimeOffPage /> },
  ],
}

const UserTimeOffRoutesWrapper: React.FC = () => {
  const { userProfile } = useAuth()

  return (
    <EmployeeTimeOffConfigProvider employeeId={userProfile?.employeeId} year={dayjs().year()}>
      <Outlet />
    </EmployeeTimeOffConfigProvider>
  )
}

export const userTimeOffRoutes: RouteObject = {
  path: 'time-off',
  element: (
    <Suspense fallback={<SuspenseLoading />}>
      <DocumentStorageConfigProvider documentBucket="employee">
        <UserTimeOffRoutesWrapper />
      </DocumentStorageConfigProvider>
    </Suspense>
  ),
  children: [
    { index: true, element: <MyTimeOffPage /> },
    { path: 'approval', element: <TimeOffApprovalPage /> },
    { path: 'calendar', element: <TimeOffCalendarPage /> },
  ],
}